module.exports = __webpack_public_path__ + "img/gurugram-branch.675ea7da.jpg";